import React, { Component, createRef } from "react";
import PropTypes from "prop-types";
import Modal from "./Modal";
import Button from "./Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

/**
 * @augments {Component<ModalQuestion.propTypes, {}>}
 */
class ModalQuestion extends Component {
  static propTypes = {
    image: PropTypes.string,
    title: PropTypes.string,
    member: PropTypes.string,
    memberFor: PropTypes.string,
    color: PropTypes.string,
    text_color: PropTypes.string,
    question: PropTypes.string,
    headerColor: PropTypes.string,
    headerBg: PropTypes.string,
    submitButton: PropTypes.shape(Button.propTypes),

    // Time in minute
    time: PropTypes.number,
    isOpen: PropTypes.bool
  };

  static defaultProps = {
    isOpen: false
  };

  constructor(props) {
    super(props);
    this.state = {
      timeLeft: props.time,
      timer: null,
      isOpenTeamAction: false,
      teamAction: "",
      isSubmitted: false,
      isMaxChar: false,
      isDisabled: false,
      popup_text: window.team_action.team_action_popup_text,
      addTeamActionText: window.team_action.team_action_add_button_text
        ? window.team_action.team_action_add_button_text
        : "Add",
      editTeamActionText: window.team_action.team_action_edit_button_text
        ? window.team_action.team_action_edit_button_text
        : "Edit"
    };

    this.teamActionField = createRef();
  }

  componentDidUpdate(prevProps, prevState) {
    if (!prevProps.isOpen && this.props.isOpen) {
      // Opening Modal, before its get rendered
      this.setTimer();
    } else if (prevProps.isOpen && !this.props.isOpen) {
      //  Closing Modal, before its get rendered
      this.resetTimer();
    }
  }

  // componentDidMount() {
  //   const customFontsHeading = new FontFace(
  //     "Custom Fonts Heading",
  //     `url(${this.state.font_heading})`
  //   );
  //   const customFontsBody = new FontFace(
  //     "Custom Fonts Heading",
  //     `url(${this.state.font_body})`
  //   );

  //   customFontsHeading.load().then(() => {
  //     document.fonts.add(customFontsHeading);
  //   });

  //   customFontsBody.load().then(() => {
  //     document.fonts.add(customFontsBody);
  //   });
  // }

  setTimer = () => {
    let timeLeft = this.props.time;
    const timer = setInterval(() => {
      timeLeft -= 1;

      if (timeLeft >= 0) {
        this.setState({
          timeLeft: timeLeft
        });
      } else {
        clearInterval(timer);
      }
    }, 1000);

    this.setState({
      timeLeft: timeLeft,
      timer: timer
    });
  };

  inputTeamAction = e => {
    const val = e.target.value;
    this.setState({
      teamAction: val
    });

    if (e.target.value.length >= 950) {
      this.setState({ isMaxChar: true });

      // this.state.isDisabled = true;
      this.props.isMaxChar();
    } else {
      this.setState({ isMaxChar: false });
    }
  };

  handleEdit = e => {
    e.preventDefault();
    this.setState({ isSubmitted: false });
  };

  onSubmitTeamAction = e => {
    e.preventDefault();
    this.setState({ isSubmitted: true });
  };

  resetTimer = () => {
    const timer = this.state.timer;
    clearInterval(timer);
  };

  handleClose = () => {
    this.props.onSubmitTeamAction(this.state.teamAction);
    this.setState({
      teamAction: "",
      isSubmitted: false,
      isOpenTeamAction: false
    });
  };

  toggleTeamAction = () => {
    this.setState({ isOpenTeamAction: !this.state.isOpenTeamAction });
  };

  render() {
    const twoDigit = number => (number < 10 ? `0${number}` : number);

    const timeLeft = this.state.timeLeft;
    const minute = Math.floor(timeLeft / 60);
    const second = timeLeft - 60 * minute;
    const minuteLeft = twoDigit(minute);
    const secondLeft = twoDigit(second);

    const hangerUrl = `/wp-content/themes/teamconnector2/assets/images/hanger.png`;

    return (
      <Modal
        className="question"
        isOpen={this.props.isOpen}
        isWithCloseButton={false}
      >
        <div
          className="modal-question"
          style={{ background: this.props.color }}
        >
          {/* <div className="modal-question-overlay" /> */}
          <div className="modal-question-header">
            <div className="modal-question-header__left">
              <div className="modal-question-timer font-additional">
                <FontAwesomeIcon icon={["far", "clock"]} className="icon" />
                <div>
                  <span>{minuteLeft}</span>
                  <span>:</span>
                  <span>{secondLeft}</span>
                </div>
              </div>
            </div>
            <div className="modal-question-header__member">
              <div className="modal-question-member-title" style={{color: this.props.text_color}}>
                <span>{this.props.memberFor}</span>
              </div>
              <div className="modal-question-member-value" style={{color: this.props.text_color}}>
                <span>{this.props.member}</span>
              </div>
            </div>
            <div className="modal-question-header__close-button">
              {/* <button
                onClick={() => this.handleClose()}
                className="button-text"
                title="close"
              >
                <svg width="34" height="34" viewBox="0 0 34 34" fill="none">
                  <path
                    d="M25.5 8.5L8.5 25.5"
                    stroke="#fff"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M8.5 8.5L25.5 25.5"
                    stroke="#fff"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button> */}
            </div>
          </div>
          <div className="modal-question-body">
            <div className="modal-question-body__main">
              <h4
                className="modal-question-body__main-title"
                dangerouslySetInnerHTML={{ __html: this.props.title }}
                style={{color: this.props.text_color}}
              />

              <div
                className="modal-question-body__main-content"
                dangerouslySetInnerHTML={{ __html: this.props.question }}
                style={{color: this.props.text_color}}
              />
            </div>
          </div>
          <div
            className={
              this.state.isOpenTeamAction
                ? "modal-question-footer is-open"
                : "modal-question-footer"
            }
          >
            <div
              className={
                this.state.isOpenTeamAction
                  ? "modal-question-footer__left is-open"
                  : "modal-question-footer__left"
              }
              onClick={() => this.toggleTeamAction()}
            >
              <div className="modal-question-footer__left-button">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                  <path d="M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32V224H48c-17.7 0-32 14.3-32 32s14.3 32 32 32H192V432c0 17.7 14.3 32 32 32s32-14.3 32-32V288H400c17.7 0 32-14.3 32-32s-14.3-32-32-32H256V80z" />
                </svg>
              </div>
              <div className="modal-question-footer__left-text" style={{color: this.props.text_color}}>
                <p>{this.state.popup_text}</p>
              </div>
            </div>
            <div
              className={
                this.state.isOpenTeamAction
                  ? "modal-question-footer__right is-open"
                  : "modal-question-footer__right"
              }
              onClick={() => this.handleClose()}
            >
              <div className="modal-question-footer__right-button">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                  <path d="M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z" />
                </svg>
              </div>
              <div className="modal-question-footer__right-text" style={{color: this.props.text_color}}>
                <p>{window.question.back_to_wheel}</p>
              </div>
            </div>
          </div>
        </div>
        <div
          className={
            this.state.isOpenTeamAction
              ? "team-action-container is-open"
              : "team-action-container"
          }
        >
          <div className="modal-question-hanger">
            <picture className="modal-question-hanger__left">
              <source srcSet={hangerUrl} type="image/png" />
              <img src={hangerUrl} alt="Union" />
            </picture>
            <picture className="modal-question-hanger__right">
              <source srcSet={hangerUrl} type="image/png" />
              <img src={hangerUrl} alt="Union" />
            </picture>
          </div>

          <div className="team-action">
            <div className="team-action-header">
              <p className="team-action-header-text">{this.state.popup_text}</p>
            </div>
            <form onSubmit={this.onSubmitTeamAction}>
              <div
                className={`modal-question-body__team-action ${
                  this.state.isSubmitted ? "isSubmitted" : ""
                }`}
              >
                <div
                  className={`modal-question-body__team-action_input ${
                    this.state.isSubmitted ? "isSubmitted" : ""
                  }`}
                >
                  <input
                    className="input-action"
                    type="text"
                    value={this.state.teamAction}
                    onChange={e => this.inputTeamAction(e)}
                    placeholder={
                      window.team_action.team_action_placeholder_text
                    }
                    disabled={this.state.isDisabled}
                  />
                </div>
                <div
                  className={`modal-question-body__team-action-content ${
                    this.state.isSubmitted ? "isSubmitted" : ""
                  }`}
                >
                  <span
                    className={`modal-question-body__team-action-content-item ${
                      this.state.isMaxChar ? "max-char" : ""
                    }`}
                  >
                    {this.state.teamAction}
                  </span>
                </div>

                <div
                  className={`modal-question-body__cta ${
                    this.state.teamAction.length !== 0 ? "active" : ""
                  }`}
                >
                  <span>
                    {window.setup_team.setup_team_member_added_feedback_text}
                  </span>
                  <Button
                    onClick={
                      this.state.isSubmitted
                        ? this.handleEdit
                        : this.onSubmitTeamAction
                    }
                    text={
                      this.state.isSubmitted
                        ? this.state.editTeamActionText
                        : this.state.addTeamActionText
                    }
                  />
                </div>
              </div>
            </form>
          </div>
        </div>
      </Modal>
    );
  }
}

export default ModalQuestion;
